import { gql } from '@apollo/client';
import { PatientInfoShared } from '../fragments';

export default gql`
  query patient($id: ID) {
    patient(id: $id) {
      ...PatientInfoShared
    }
  }
  ${PatientInfoShared}
`;
